var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"wp-header"},[_c('a',{staticClass:"logo",attrs:{"href":"/","title":"迅雷"}}),_vm._v(" "),_c('Input'),_vm._v(" "),_c('ul',{staticClass:"header-nav"},_vm._l((_vm.tabs),function(item,i){return _c('li',{key:i},[(item.target)?_c('a',{attrs:{"href":item.path,"target":"_blank"},on:{"click":function($event){return _vm.$util.clickStat(
              `GWSY/TAG${item.name}`,
              `官网首页/标签栏${item.title}`
            )}}},[_vm._v("\n          "+_vm._s(item.title)+"\n        ")]):_c('a',{class:{ cur: _vm.checkPath(item.path) },attrs:{"href":"javascript:;"},on:{"click":function($event){_vm.jump(item, i)
            _vm.$util.clickStat(
              `GWSY/TAG${item.name}`,
              `官网首页/标签栏${item.title}`
            )}}},[_vm._v("\n          "+_vm._s(item.title)+"\n        ")])])}),0)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }